import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/account" replace />;
  if (!user.roles?.includes('admin')) return <Navigate to="/" replace />;
  return children;
}
